// client/src/state/apolloClient.js

import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

// Generic auth link
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

// Base URLs for each service
const urls = {
  user: process.env.REACT_APP_USER_GRAPHQL_URL,
  role: process.env.REACT_APP_ROLES_GRAPHQL_URL,
  group: process.env.REACT_APP_GROUPS_GRAPHQL_URL,
  account: process.env.REACT_APP_ACCOUNTS_GRAPHQL_URL,
};

// Create Apollo clients per service
export const userClient = new ApolloClient({
  link: authLink.concat(createHttpLink({ uri: urls.user })),
  cache: new InMemoryCache(),
});

export const roleClient = new ApolloClient({
  link: authLink.concat(createHttpLink({ uri: urls.role })),
  cache: new InMemoryCache(),
});

export const groupClient = new ApolloClient({
  link: authLink.concat(createHttpLink({ uri: urls.group })),
  cache: new InMemoryCache(),
});

export const accountClient = new ApolloClient({ // ✅ New client for transactions
  link: authLink.concat(createHttpLink({ uri: urls.account })),
  cache: new InMemoryCache(),
});
